module.exports = __webpack_public_path__ + "static/img/156.c93eb3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/156.png
// module id = lnhc
// module chunks = 0